<app-resp-popup-title i18n="Eine neue Aufgabe erstellen@@CreateNewTask">
  Create a new Task
</app-resp-popup-title>
<app-resp-popup-content>
  @if (form) {
    <form [formGroup]="form" style="width: 800px; max-width: 90vw">
      <div class="row">
        <div class="col-12 col-lg-6">
          <fieldset>
            <legend i18n="Definition@@TaskInsertDefinition">Definition</legend>
            <div class="row">
              <div class="col">
                <frm-planung-task-category-select
                  id="taskInsertCategorySelect"
                  formControlName="categoryID"
                ></frm-planung-task-category-select>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <frm-text
                  id="taskInsertTitleInput"
                  i18n-label="Aufgabentitel@@TaskTitel"
                  label="Task Title"
                  formControlName="label"
                ></frm-text>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <frm-text
                  id="taskInsertDescriptionInput"
                  i18n-label="Aufgabentitel@@Description"
                  label="Description"
                  formControlName="description"
                  [multiline]="true"
                  [rows]="9"
                ></frm-text>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-12 col-lg-6">
          <fieldset>
            <legend i18n="Details@@TaskInsertdetails">Details</legend>
            <div class="row">
              <div class="col">
                <frm-planung-resource-select
                  id="taskInsertAssignedToSelect"
                  i18n-label="Vorgesehen für@@MeantFor"
                  label="Assigned To"
                  formControlName="assignedToResourceID"
                  [onlyUsers]="false"
                ></frm-planung-resource-select>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <app-task-status-droplist
                  id="taskInsertStateSelect"
                  i18n-label="Status@@status"
                  label="Status"
                  formControlName="state"
                  [isMultiselect]="false"
                  [forFilter]="false"
                >
                </app-task-status-droplist>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <frm-anlage-facility-no-select
                  id="taskInsertFacilitySelect"
                  i18n-label="Anlage@@facility"
                  label="Facility"
                  formControlName="anlageNrIntern"
                  (facilitySelected)="onFacilitySelected($event)"
                />
              </div>
            </div>
            <div class="row">
              <div class="col">
                <app-anlage-group-select
                  id="taskInsertFacilityGroupSelect"
                  [selectedItem]="anlageGroup"
                  (selectedItemChange)="anlageGroup = $event"
                  [allowCustomValue]="true"
                ></app-anlage-group-select>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-12 col-lg-6">
          <fieldset formGroupName="workLocation">
            <legend i18n="@@ActivityLocation">Activity Location</legend>
            <div class="row">
              <div class="col">
                <frm-text
                  id="taskInsertWorkLocationNameInput"
                  i18n-label="@@worklocation_name"
                  label="Location Label"
                  formControlName="name"
                ></frm-text>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-8">
                <frm-text
                  id="taskInsertWorkLocationStreetInput"
                  i18n-label="@@worklocation_street"
                  label="Street"
                  formControlName="street"
                ></frm-text>
              </div>
              <div class="col-12 col-md-4">
                <frm-text
                  id="taskInsertWorkLocationStreetNoInput"
                  i18n-label="@@worklocation_streetNo"
                  label="Street No."
                  formControlName="streetNo"
                ></frm-text>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-4">
                <frm-text
                  id="taskInsertWorkLocationPostalCodeInput"
                  i18n-label="@@worklocation_postalCode"
                  label="Postal Code"
                  formControlName="postalCode"
                ></frm-text>
              </div>
              <div class="col-12 col-md-8">
                <frm-text
                  id="taskInsertWorkLocationCityInput"
                  i18n-label="@@worklocation_city"
                  label="City"
                  formControlName="city"
                ></frm-text>
              </div>
            </div>
          </fieldset>
        </div>
        @if (!isSaasInstance) {
          <div class="col-12 col-lg-6">
            <fieldset>
              <legend i18n="Sonstiges@@else">Misc</legend>
              <frm-time-picker
                id="taskInsertWorkTimePlannedInput"
                mode="timeSpan"
                formControlName="workTimePlanned"
                label="Target work time (hours : minutes)"
                i18-label="@@TargetWorkTimePlusHaM"
              ></frm-time-picker>
              <div formGroupName="workLocation">
                <frm-time-picker
                  id="taskInsertDriveTimePlannedInput"
                  mode="timeSpan"
                  formControlName="driveTimePlanned"
                  label="Planned driving time (hours : minutes)"
                  i18-label="@@PlannedDrivingTime"
                ></frm-time-picker>
                <frm-text
                  id="taskInsertKilometresPlannedInput"
                  formControlName="kilometresPlanned"
                  label="Planned kilometer"
                  i18-label="Geplante Kilometer@@PlannedKilom"
                  [type]="number"
                  [min]="0"
                  [max]="9999999"
                ></frm-text>
              </div>
            </fieldset>
          </div>
        }
      </div>
      <br />
      <div class="row">
        <div class="col">
          <fieldset>
            <legend i18n="Zeitliche Einplanung@@TaskInsertTimedPlanning">
              Timed planning
            </legend>
            <div class="row">
              <div class="col-6">
                <frm-appointment-arrangement-select
                  id="taskInsertAppointmentArrangementSelect"
                  formControlName="appointmentArrangement"
                ></frm-appointment-arrangement-select>
              </div>
            </div>
            @if (isSaasInstance) {
              <div class="row" style="margin-top: 15px">
                <div class="col" formGroupName="dateRanges">
                  <frm-text
                    id="taskInsertCalendarWeekInput"
                    i18n-label="@@PlanungAPI_TaskInsert_CalendarWeek_Label"
                    label="Planned for CW"
                    formControlName="rawCalendarWeek"
                    mask="[0-5][0-9]/[0-9][0-9][0-9][0-9]"
                    (valueChanged)="OnCalendarWeekInputChange(true)"
                    i18n-placeholder="
                      @@PlanungAPI_TaskInsert_CalendarWeek_Placeholder"
                    placeholder="CW/YYYY"
                    i18n-hint="@@PlanungAPI_TaskInsert_CalendarWeek_Hint"
                    hint="eg. 19/2025, 43/2026, 51/2026"
                    [validationMessages]="{
                      pattern: validationMessageCalendarWeekPattern,
                      invalidWeek: validationMessageCalendarWeekInvalid,
                    }"
                  >
                  </frm-text>
                </div>
                <div class="col">
                  <frm-date-picker
                    id="taskInsertDueDateInput"
                    label="Fälligkeitsdatum"
                    formControlName="dueDate"
                    normalize="mid_of_day"
                    [showReset]="true"
                  ></frm-date-picker>
                </div>
              </div>
            } @else {
              <div class="row">
                <div class="col">
                  <div>
                    <mat-checkbox
                      id="taskInsertDateRangesActiveCheckbox"
                      i18n="Termin aktiv@@appointmentactive"
                      color="primary"
                      formControlName="dateRangesActive"
                      >Appointment active
                    </mat-checkbox>
                    <span i18n="@@TaskInsertNotActiveMeans" class="small block"
                      >Not active means the appointments are just for
                      documentary purpose but won't be considered. The task
                      appears in the unplanned appiontments.<br />
                      Not active means the entries will be considered.
                    </span>
                  </div>
                </div>
              </div>
              <hr />
              <div [style.opacity]="areDateRangesActive ? 1 : 0.5">
                <div class="row" formGroupName="dateRanges">
                  <div class="col" formGroupName="periodOfAction">
                    <frm-dropdown
                        id="taskInsertPeriodMonthSelect"
                      label="Zu erledigen in"
                      formControlName="month"
                      [displayOnly]="areDateRangesActive ? false : true"
                      [dropdownType]="dropDownType.DropDownList"
                      [items]="months"
                      (selectionChange)="OnYearPeriodInputChange(true)"
                    ></frm-dropdown>
                    <frm-text
                      formControlName="year"
                      [displayOnly]="areDateRangesActive ? false : true"
                      [type]="number"
                      [min]="1994"
                      [max]="9999"
                      (input)="OnYearPeriodInputChange(true)"
                    ></frm-text>
                  </div>
                  <div class="col">
                    <frm-text
                      [displayOnly]="areDateRangesActive ? false : true"
                      i18n-label="@@PlanungAPI_TaskInsert_CalendarWeek_Label"
                      label="Planned for CW"
                      formControlName="rawCalendarWeek"
                      mask="[0-5][0-9]/[0-9][0-9][0-9][0-9]"
                      (valueChanged)="OnCalendarWeekInputChange(true)"
                      i18n-placeholder="
                        @@PlanungAPI_TaskInsert_CalendarWeek_Placeholder"
                      placeholder="CW/YYYY"
                      i18n-hint="@@PlanungAPI_TaskInsert_CalendarWeek_Hint"
                      hint="eg. 19/2025, 43/2026, 51/2026"
                      [validationMessages]="{
                        pattern: validationMessageCalendarWeekPattern,
                        invalidWeek: validationMessageCalendarWeekInvalid,
                      }"
                    >
                    </frm-text>
                  </div>
                  <div class="col">
                    <frm-date-picker
                      id="taskInsertTodoDateInput"
                      [displayOnly]="areDateRangesActive ? false : true"
                      label="Plantermin"
                      formControlName="todoDate"
                      normalize="mid_of_day"
                      [showReset]="true"
                      (valueChanged)="OnTodoDateInputChange(true)"
                    ></frm-date-picker>
                    <frm-time-picker
                      id="taskInsertTodoTimeInput"
                      [displayOnly]="areDateRangesActive ? false : true"
                      formControlName="todoTime"
                      i18n-label="@@TaskDetailPlannedTime"
                      label="Time of day"
                    ></frm-time-picker>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-top: 15px">
                <div class="col">
                  <frm-date-picker
                    id="taskInsertLegacyDueDateInput"
                    [displayOnly]="areDateRangesActive ? false : true"
                    label="Fälligkeitsdatum"
                    formControlName="dueDate"
                    normalize="mid_of_day"
                    [showReset]="true"
                  ></frm-date-picker>
                </div>
                <div class="col"></div>
                <div class="col"></div>
              </div>
            }
          </fieldset>
        </div>
      </div>
      <br />
      @if (CanSendNotification()) {
        <div class="row">
          <div class="col">
            <fieldset>
              <legend i18n="@@TaskInsert_Notification">
                Push-Notification
              </legend>
              <div class="row">
                <div class="col" style="margin-top: 15px">
                  <frm-check
                    id="taskInsertSendNotificationCheckbox"
                    i18n-label="@@TaskInsert_SendNotificationLabel"
                    label="Send Push-Notification to assigned user"
                    formControlName="sendPushNotification"
                  ></frm-check>
                </div>
                @if (false) {
                  <div class="col">
                    <!-- #9652 vorerst auf HIDE setzen -->
                    <frm-dropdown
                      i18n-label="@@TaskInsert_NotificationTagLabel"
                      label="Notification-Category"
                      formControlName="pushNotificationTag"
                      [defaultItem]="{
                        value: '',
                        label: '-- Ohne Kategorie --',
                      }"
                      [items]="[
                        { value: 'Wartung', label: 'Wartung' },
                        { value: 'Störung', label: 'Störung' },
                      ]"
                    ></frm-dropdown>
                  </div>
                }
              </div>
            </fieldset>
          </div>
        </div>
      }
      <br />
    </form>
  }
</app-resp-popup-content>
<app-resp-popup-actions>
  <button
    type="button"
    mat-raised-button
    color="primary"
    id="taskInsertSaveButton"
    (click)="OnAccept()"
    iconClass="fa fa-check fa-fw"
    [disabled]="!form.valid"
    i18n="@@busave"
  >
    Save
  </button>
  <button
    type="button"
    mat-raised-button
    id="taskInsertCancelButton"
    (click)="OnCancel()"
    iconClass="fa fa-times fa-fw"
    i18n="@@bucancel"
  >
    Cancel
  </button>
</app-resp-popup-actions>
